const API_URLS = {
    base: "https://oneliker.nl/be/store",
    // proxy: "http://localhost:4000"
};

export default API_URLS;